let router = null

export const initRouter = (instance) => {
    router = instance
}

export const $goTo = (path, params = {}) => {
    if (!router) {
        console.error('router 实例未初始化')
        return Promise.reject(new Error('router 实例未初始化'))
    }

    const target =
        typeof path === 'object'
            ? path
            : Object.keys(params).length
                ? { path, query: params }
                : { path }

    // 解析目标路由
    const { route } = router.resolve(target)

    // 当前路由与目标路由一致
    if (route.fullPath === router.currentRoute.fullPath) {
        return Promise.resolve(route)
    }

    return router.push(target).catch(err => {
        // 忽略重复导航
        if (err.name === 'NavigationDuplicated') {
            return err
        }

        throw err
    })
}

export const $goBack = (n = 1) => {
    if (!router) return
    router.go(-n)
}

export const $replace = (path, params = {}) => {
    if (!router) return

    if (typeof path === 'object') {
        router.replace(path)
    } else if (Object.keys(params).length > 0) {
        router.replace({ path, query: params })
    } else {
        router.replace(path)
    }
}

export const $goToName = (name, params = {}, query = {}) => {
    if (!router) return
    router.push({ name, params, query })
}